import React from "react";
import Module from "components/module";

const RenderModules = ({ modules, className, ...other }) => {
	if (!modules) return;

	return modules?.map((module) => {
		// If the module is a reference, use its content; otherwise, use the module directly
		const data = module._type === "module" ? module.content : module;
		return <Module
			settings={data.settings}
			key={data._key}
			content={data}
			className={className}
			{...other}
		/>;
	}
	);
};

export default RenderModules;
